import axios from "axios";
import React, { useEffect, useState } from "react";
import Keyring from "@polkadot/keyring";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import routes from "../../../constants/routes";
import { CodePromise } from "@polkadot/api-contract";
import useConnectWs from "../../../hooks/useConnectWs";
import contractERC20 from "../../../contract/erc20.json";
import {
  convertAmountWithDecimals,
  saveDataTokenCreate,
} from "../../../utils/Helpers";
import { setPopupMessage } from "../../../redux/popupMessage";

const CreateToken3 = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [fileIcon, setFileIcon] = useState(null);
  const [form, setForm] = useState({
    token_name: "",
    short_name: "",
    total_supply: 0,
    owner: "",
  });
  const [api, setApi] = useConnectWs();

  const { account, mnemonic } = useSelector((state) => state.account);

  useEffect(() => {
    if (account) {
      setForm((prev) => ({
        ...prev,
        owner: account.address,
      }));
    } else {
      history(routes?.dashboard);
    }
  }, [account]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (api) {
      (async function () {
        const code = new CodePromise(
          api,
          contractERC20,
          contractERC20.source.wasm
        );
        const gasLimit = 100000n * 1000000n;
        const storageDepositLimit = null;
        const initValue = convertAmountWithDecimals(form.total_supply).toFixed(
          0
        );
        const tx = code.tx.new(
          { gasLimit, storageDepositLimit },
          initValue,
          form.token_name,
          form.short_name
        );

        let address = "";

        const keyring = new Keyring({ type: "sr25519" });
        const pairMe = keyring.addFromUri(mnemonic);

        dispatch(setPopupMessage("Create Token status: Init"));

        const unsub = await tx.signAndSend(pairMe, ({ contract, status }) => {
          if (status.isInBlock || status.isFinalized) {
            address = contract.address.toString();
            unsub();
            dispatch(setPopupMessage("Create Token status:" + status.type));
            saveToService(address);
          }
        });
      })();
    }
  };

  const saveToService = (address) => {
    const json = JSON.stringify({
      data: {
        token_contract: address,
      },
    });
    axios
      .post(process.env.REACT_APP_API_URL + "api/tokens", json, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        saveDataTokenCreate(response.data.data.attributes);
        dispatch(setPopupMessage("Successfully"));
        history(routes?.createToken4);
      })
      .catch((error) => {});
  };

  // xử lý upload file icon
  // useEffect(() => {
  //     var boxUploadIcon = document.querySelector("#boxUploadIcon");
  //     var inputUploadIcon = document.querySelector("#inputUploadIcon");
  //     var previewIcon = document.querySelector("#previewIcon");
  //     function handleClick() {
  //         inputUploadIcon.click();
  //     }
  //     function handleChangeInput(e) {
  //         previewIcon.setAttribute(
  //             "src",
  //             URL.createObjectURL(e.target.files[0])
  //         );
  //         setFileIcon(e.target.files[0]);
  //     }
  //     function handleDrop(e) {
  //         previewIcon.setAttribute(
  //             "src",
  //             URL.createObjectURL(e.dataTransfer.files[0])
  //         );
  //         setFileIcon(e.dataTransfer.files[0]);
  //     }
  //     function preventDefaults(e) {
  //         e.preventDefault();
  //         e.stopPropagation();
  //     }
  //     boxUploadIcon.addEventListener("click", handleClick);
  //     boxUploadIcon.addEventListener("drop", handleDrop);
  //     inputUploadIcon.addEventListener("change", handleChangeInput);
  //     ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
  //         boxUploadIcon.addEventListener(eventName, preventDefaults, false);
  //     });
  //     boxUploadIcon.addEventListener("drop", handleDrop, false);

  //     return () => {
  //         boxUploadIcon.removeEventListener("click", handleClick);
  //         boxUploadIcon.removeEventListener("drop", handleDrop);
  //         inputUploadIcon.removeEventListener("change", handleChangeInput);
  //         ["dragenter", "dragover", "dragleave", "drop"].forEach(
  //             (eventName) => {
  //                 boxUploadIcon.removeEventListener(
  //                     eventName,
  //                     preventDefaults,
  //                     false
  //                 );
  //             }
  //         );
  //         boxUploadIcon.removeEventListener("drop", handleDrop, false);
  //     };
  // }, []);

  return (
    <div className="pages-createToken3">
      <div className="box">
        <div className="top">
          <div className="left">{t("createToken.Create my Token")}</div>
          <Link to={routes.createToken} className="right g-buttonHover">
            {t("createToken.Back")}
          </Link>
        </div>
        <form action={routes.createToken4} onSubmit={handleSubmit}>
          <div className="formGroup">
            <label>{t("createToken.Token Name")}</label>
            <input
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  token_name: e.target.value,
                }))
              }
              required
            />
            <div className="info">
              <img src="/images/info.svg" alt="" />
              <div className="text">{t("createToken.tooltipTokenName")}</div>
            </div>
          </div>
          <div className="formGroup">
            <label>{t("createToken.Token Symbol")}</label>
            <input
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  short_name: e.target.value,
                }))
              }
              required
            />
            <div className="info">
              <img src="/images/info.svg" alt="" />
              <div className="text">{t("createToken.tooltipTokenSymbol")}</div>
            </div>
          </div>
          <div className="formGroup">
            <label>{t("createToken.Total supply")}</label>
            <input
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  total_supply: parseFloat(e.target.value),
                }))
              }
              type="number"
              defaultValue={0}
              required
            />
            <div className="info">
              <img src="/images/info.svg" alt="" />
              <div className="text">{t("createToken.tooltipTokenDecimal")}</div>
            </div>
          </div>
          {/* <div className="formGroup">
            <label>{t("createToken.Icon")}</label>
            <input
              name="icon"
              type="file"
              hidden={true}
              id="inputUploadIcon"
              accept="image/*"
            />
            <div className="drop">
              <div className="icon">
                <img src="/images/icon.svg" alt="" id="previewIcon" />
              </div>
              <div className="box" id="boxUploadIcon">
                <img src="/images/upload.svg" alt="" />
                <div>
                  <span>Click to upload</span> or drag and drop <br /> SVG, PNG,
                  JPG or GIF (max. 800x400px)
                </div>
              </div>
            </div>
          </div> */}
          <button className="submit g-buttonHover">
            {t("createToken.Create Token")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateToken3;
